const req = require.context('./js', true, /\.js$/);
req.keys().forEach(req);